import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '@/views/home/Home.vue';
import HomeLayout from '@/views/home/Layout.vue';
import { isLogin, SHOW_BRAND } from '@/utils';
import ContestLayout from '@/views/contest/Layout/index.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
      },
      {
        path: 'activity/:type/:activityId?/:itemId?/:suffix(s/.+)?',
        name: 'ActivityDetail',
        component: () =>
          import(
            /* webpackChunkName: "ActivityDetail" */ '../views/activity/ActivityDetail.vue'
          ),
        meta: {
          storeLoginUrl: true,
        },
      },
      {
        path: 'item/faq',
        name: 'ItemFaq',
        component: () =>
          import(/* webpackChunkName: "ItemFaq" */ '../views/item/ItemFaq.vue'),
      },
      // {
      //   path: 'item/info',
      //   name: 'ItemInfo',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "ItemInfo" */ '../views/item/ItemInfo.vue'
      //     ),
      // },
      {
        path: 'item/:id/apply',
        name: 'ItemApply',
        component: () =>
          import(
            /* webpackChunkName: "ItemApply" */ '../views/item/ItemApply.vue'
          ),
        meta: {
          // auth: true,
        },
      },
      {
        path: 'item/:id/:_(s)?/:suffix?',
        name: 'ItemDetail',
        component: () =>
          import(
            /* webpackChunkName: "ItemDetail" */ '../views/item/ItemDetail.vue'
          ),
        meta: {
          storeLoginUrl: true,
        },
      },
      {
        path: 'excellent',
        name: 'UserExcellent',
        component: () =>
          import(
            /* webpackChunkName: "UserExcellent" */ '../views/user/UserExcellent.vue'
          ),
      },
      {
        path: 'user',
        name: 'UserItemList',
        component: () =>
          import(
            /* webpackChunkName: "UserItemList" */ '../views/user/UserItemList.vue'
          ),
        meta: {
          // auth: true,
        },
      },
      {
        path: 'user/item/:id',
        name: 'UserItemDetail',
        component: () =>
          import(
            /* webpackChunkName: "UserItemDetail" */ '../views/user/UserItemDetail.vue'
          ),
        meta: {
          auth: true,
        },
      },
      {
        path: 'envcheck',
        name: 'UserEnvCheck',
        component: () =>
          import(
            /* webpackChunkName: "UserEnvCheck" */ '../views/user/UserEnvCheck.vue'
          ),
        meta: {
          auth: true,
        },
      },
      {
        path: 'why-learn-program',
        name: 'WhyLearnProgram',
        component: () =>
          import(
            /* webpackChunkName: "WhyLearnProgram" */ '../views/subpage/Why.vue'
          ),
      },
      // {
      //   path: 'program-introduce',
      //   name: 'LearnProgramIntroduce',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "LearnProgramIntroduce" */ '../views/subpage/Introduce.vue'
      //     ),
      // },
      {
        path: 'programming-test',
        name: 'ProgrammingTest',
        component: () =>
          import(
            /* webpackChunkName: "ProgrammingTest" */ '../views/subpage/ProgrammingTest.vue'
          ),
      },
      {
        path: 'device-check',
        name: 'DeviceCheck',
        component: () =>
          import(
            /* webpackChunkName: "DeviceCheck" */ '@/views/device/deviceCheck.vue'
          ),
        meta: {
          auth: false,
          ignoreQuery: true,
          logoutPath: '/user',
        },
      },
    ],
  },
  {
    path: '/userexam/:id/:answerId?/:suffix?',
    name: 'Examination',
    component: () =>
      import(
        /* webpackChunkName: "Examination" */ '../views/examination/Examination.vue'
      ),
    meta: {
      auth: true,
      contestListPath: {
        aild: '/contest/2025/aild',
        icc: '/contest/2025/icc',
      },
    },
  },
  {
    path: '/other-platform/auth',
    name: 'OtherPlatformAuth',
    component: () =>
      import(
        /* webpackChunkName: "otherPlatform" */ '../views/otherPlatform/auth/index.vue'
      ),
    meta: {
      notInit: true,
    },
  },
  {
    path: '/contest/2025/icc/login',
    name: 'Contest2025IccLogin',
    component: () =>
      import(
        /* webpackChunkName: "Contest2025IccLogin" */ '../views/contest/2025/icc/login/index.vue'
      ),
    meta: {
      notInit: true,
      entryUrlName: 'Contest2025IccEntry',
    },
  },
  {
    path: '/contest/2025/aild/login',
    name: 'Contest2025AildLogin',
    component: () =>
      import(
        /* webpackChunkName: "Contest2025AildLogin" */ '../views/contest/2025/aild/login/index.vue'
      ),
    meta: {
      notInit: true,
      entryUrlName: 'Contest2025AildEntry',
    },
  },
  {
    path: '/contest/2025',
    component: ContestLayout,
    children: [
      {
        path: 'aild',
        name: 'Contest2025AildEntry',
        component: () =>
          import(
            /* webpackChunkName: "Contest2025AildEntry" */ '../views/contest/2025/aild/entry/index.vue'
          ),
        meta: {
          auth: true,
          loginUrlName: 'Contest2025AildLogin',
          detailPathName: 'Contest2025AildExamDetail',
          deviceCheckName: 'ContestAildDeviceCheck',
          platform: 'aild',
        },
      },
      {
        path: 'icc',
        name: 'Contest2025IccEntry',
        component: () =>
          import(
            /* webpackChunkName: "Contest2025IccEntry" */ '../views/contest/2025/icc/entry/index.vue'
          ),
        meta: {
          auth: true,
          loginUrlName: 'Contest2025IccLogin',
          detailPathName: 'Contest2025IccExamDetail',
          deviceCheckName: 'ContestIccDeviceCheck',
          platform: 'icc',
        },
      },
      {
        path: 'aild/detail/:id',
        name: 'Contest2025AildExamDetail',
        component: () =>
          import(
            /* webpackChunkName: "UserItemDetail" */ '../views/user/UserItemDetail.vue'
          ),
        meta: {
          auth: true,
          loginUrlName: 'Contest2025AildLogin',
          entryUrlName: 'Contest2025AildEntry',
          isExternalContest: true,
          platform: 'aild',
        },
      },
      {
        path: 'icc/detail/:id',
        name: 'Contest2025IccExamDetail',
        component: () =>
          import(
            /* webpackChunkName: "UserItemDetail" */ '../views/user/UserItemDetail.vue'
          ),
        meta: {
          auth: true,
          loginUrlName: 'Contest2025IccLogin',
          entryUrlName: 'Contest2025IccEntry',
          isExternalContest: true,
          platform: 'icc',
        },
      },
      {
        path: 'alid/device-check',
        name: 'ContestAildDeviceCheck',
        component: () =>
          import(
            /* webpackChunkName: "DeviceCheck" */ '@/views/device/deviceCheck.vue'
          ),
        meta: {
          auth: true,
          ignoreQuery: true,
          loginUrlName: 'Contest2025AildLogin',
          entryUrlName: 'Contest2025AildEntry',
          isExternalContest: true,
          platform: 'aild',
        },
      },
      {
        path: 'icc/device-check',
        name: 'ContestIccDeviceCheck',
        component: () =>
          import(
            /* webpackChunkName: "DeviceCheck" */ '@/views/device/deviceCheck.vue'
          ),
        meta: {
          auth: true,
          ignoreQuery: true,
          loginUrlName: 'Contest2025IccLogin',
          entryUrlName: 'Contest2025IccEntry',
          isExternalContest: true,
          platform: 'icc',
        },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    component: () =>
      import(/* webpackChunkName: "404" */ '../views/404/PageNotFound.vue'),
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

router.beforeResolve(async to => {
  if (to.meta.auth) {
    if (isLogin() === false) {
      if (to.meta.loginUrlName && typeof to.meta.loginUrlName === 'string') {
        return { name: to.meta.loginUrlName };
      }
      return SHOW_BRAND ? { name: 'Home' } : '/activity/list';
    }
  }
  if (to.name === 'Home') {
    if (!SHOW_BRAND) {
      return '/activity/list';
    }
  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
